import React from "react";
import './index.scss';



const VideoModal = ({videoCode, open, setModalOpen, vidSource}) => {

    const handleClick = () => {
        setModalOpen(false);
      }

    return (
        <div className={`modal ${open ? 'show' : ''}`} tabIndex="-1">
            <div className="modal-close">
            <svg onClick={()=>handleClick()} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1243_4702)">
                <path d="M3.77817 4.22183L11.5563 12M19.3345 19.7782L11.5563 12M11.5563 12L3.77817 19.7782M11.5563 12L19.3345 4.22183" stroke="white" stroke-width="4" stroke-linecap="round"/>
                </g>
                <defs>
                <clipPath id="clip0_1243_4702">
                <rect width="24" height="24" fill="white"/>
                </clipPath>
                </defs>
            </svg>
            </div>
            <div className="modal-content">
                <div className="modal-body">
                {
                        vidSource === 'youtube' ?
                    <iframe width="560" height="315" src={`https://www.youtube.com/embed/${videoCode}`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
                    </iframe>
                        :
                        <iframe src={`https://player.vimeo.com/video/${videoCode}?autoplay=1&muted=1&loop=1?background=1`} title="Vimeo player" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                    }
                </div>  
            </div>
    </div>

    )

}

export default VideoModal